module.exports = __webpack_public_path__ + "assets/media/assessIcon.ec48053a.svg";